import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from "react-redux";

function ProductListingCategory(props) {

  // safe state init
  const [category, setCategory] = useState(
    props.listingData && props.listingData.formData && props.listingData.formData.category || ""
  );

  // restore on back
  useEffect(() => {
    setCategory(props.listingData && props.listingData.formData && props.listingData.formData.category || "");
  }, [props.listingData && props.listingData.formData && props.listingData.formData.category]);

  // next step
  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        category: category
      }
    }));

    props.nextStep();
  };

  return (
    <Container>
      <Row>

        <Col md={12} className="mt-2 mb-2">
          <h4>Step 3 : Category</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">
                Product Type :
              </Col>

              <Col md={8}>
                <Input
                  type="text"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>

          <button className="btn btn-primary" onClick={handleNext}>
            Next →
          </button>
        </Col>

      </Row>
    </Container>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(ProductListingCategory);